import React, { useContext } from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { UniversalContext } from '../../../_universal';

/**
 * A higher order component for getting the Universal context.
 */
export default function withUniversalContextComponent(WrappedComponent) {
  const componentName = WrappedComponent.displayName || WrappedComponent.name;
  const WithUniversalContext = (props) => {
    const universalContext = useContext(UniversalContext);
    return <WrappedComponent universalContext={universalContext} {...props} />;
  };
  WithUniversalContext.displayName = `withUniversalContext(${componentName})`;
  WithUniversalContext.WrappedComponent = WrappedComponent;
  hoistNonReactStatic(WithUniversalContext, WrappedComponent);

  return WithUniversalContext;
}
